import { useEffect } from "react";
import { CustomListNotifications } from "../Components/Lists/NotificationList";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { useTranslation } from "react-i18next";

export  function ListNotifications() {
    const { t } = useTranslation();
    const { setPageTitle, setPageTitleKey } = useHeader();

    useEffect(() => {
        setPageTitle(t('userNotifications.notifications'));
        setPageTitleKey('userNotifications.notifications');
        return () => { setPageTitle(''); setPageTitleKey(''); };
    }, [t]);

    return(
        <>
          <CustomListNotifications/>
        </>
    );
  }